/* eslint-disable react/no-array-index-key */
import React, { lazy, } from 'react';
import { Redirect, } from 'react-router-dom';
import { useSelector } from 'react-redux';
import VerifyYourEmail from 'src/views/auth/VerifyYourEmail';
import { useRouteMatch } from 'react-router';
import Routes from './components/Routes';
import AdminExperience from './views/AdminExperience';
import ManageWorkflow from './views/AdminExperience/Workflows/ManageProcess';
import BasicLayout from './layouts/BasicLayout';
import ManagePerspective from './views/AdminExperience/Workflows/ManagePerspective';
import { ADMIN_VIEW } from './redux/Account/constants';
import {Tab} from "./types";
import WorkflowDashboard from "./views/AdminExperience/Workflows/WorkflowDashboard";
import Integrations from "./views/AdminExperience/Integrations";

const guestRoutes: Tab[] = [
    {
        exact: true,
        route: '/login',
        component: lazy(() => import('src/views/auth/SignIn'))
    },
    {
        exact: true,
        route: '/verify-your-email',
        component: VerifyYourEmail,
    },
    {
        exact: true,
        route: '/register',
        component: lazy(() => import('src/views/auth/SignUp'))
    },
    {
        exact: true,
        route: '/forgot-password',
        component: lazy(() => import('src/views/auth/ForgotPassword'))
    },
    {
        exact: true,
        route: '/accept-invitation',
        component: lazy(() => import('src/views/auth/AcceptInvitation'))
    },
    {
        exact: true,
        route: '/start-application',
        component: lazy(() => import('src/views/auth/StartApplication'))
    },
    {
        exact: true,
        route: '/confirm-reset-password',
        component: lazy(() => import('src/views/auth/ConfirmResetPassword'))
    },
    {
        exact: true,
        route: '/',
        component: () => <Redirect to="/login"/>
    },
];
const userRoutes: Tab[] = [
    {
        route: '/',
        exact: true,
        component: lazy(() => import('src/views/UserExperience/UserDashboard')),
        layout: BasicLayout,
    },
    {
        route: '/engagements/:engagementId',
        component: lazy(() => import('src/views/UserExperience/ViewEngagement')),
        layout: BasicLayout,
    },
    {
        route: '/workflows/:workflowId',
        component: lazy(() => import('src/views/UserExperience/ViewWorkflow')),
        layout: BasicLayout,
    },
    {
        route: '/',
        component: () => <Redirect to="/"/>
    },
];
const adminRoutes: Tab[] = [
    {
        route: '/workflows/:workflowId/process',
        component: ManageWorkflow,
        layout: ({ children }: any) => <BasicLayout workflowTab="process">{children}</BasicLayout>
    },
    {
        route: '/workflows/:workflowId/perspectives/:perspectiveId?',
        component: ManagePerspective,
        layout: ({ children }: any) => <BasicLayout workflowTab="perspectives">{children}</BasicLayout>
    },
    // {
    //     route: '/workflows/:workflowId/dashboard',
    //     component: AdminExperience,
    //     layout: BasicLayout,
    // },
    {
        route: '/workflows/:workflowId',
        component: ({ match: { url } }: any) => <Redirect to={`${url}/dashboard`}/>,
        exact: true,
    },
    {
        route: '/integrations/:integration',
        component: Integrations
    },
    {
        route: '/',
        exact: false,
        component: AdminExperience,
        layout: BasicLayout,
    },
];
function MainRoutes() {
    const { url } = useRouteMatch();

    let routes;
    const account = useSelector((state) => (state as any).account);
    if (!account.user) {
        routes = guestRoutes;
    }
    else if (account.user.isTeamAdmin && account.view === ADMIN_VIEW) {
        routes = adminRoutes;
    }
    else {
        routes = userRoutes;
    }

    return <Routes routes={routes} url={url}/>;
}
export default MainRoutes;
